import { render } from "./DriverInformationModal.vue?vue&type=template&id=38add70c&scoped=true"
import script from "./DriverInformationModal.vue?vue&type=script&lang=js"
export * from "./DriverInformationModal.vue?vue&type=script&lang=js"

import "./DriverInformationModal.vue?vue&type=style&index=0&id=38add70c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38add70c"]])

export default __exports__